import { render, staticRenderFns } from "./StartBox.vue?vue&type=template&id=ea67cd80&scoped=true&"
import script from "./StartBox.vue?vue&type=script&lang=js&"
export * from "./StartBox.vue?vue&type=script&lang=js&"
import style0 from "./StartBox.vue?vue&type=style&index=0&id=ea67cd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea67cd80",
  null
  
)

export default component.exports